import pusher from "./pusher";
import BarrelType from "../model/BarrelType";
import { ORGANIZATION_CHANNEL_PREFIX, STYLEGUIDE_CHANNEL_PREFIX, PROJECT_CHANNEL_PREFIX } from "../constants";

function subscribeToChannel(prefix, id) {
    if (!prefix || !id) {
        return;
    }

    const channelName = prefix + id;
    return pusher.channel(channelName) || pusher.subscribe(channelName);
}

export function subscribeToOrganizationChannel(oid) {
    return subscribeToChannel(ORGANIZATION_CHANNEL_PREFIX, oid);
}

export function unsubscribeFromOrganizationChannel(oid) {
    pusher.unsubscribe(ORGANIZATION_CHANNEL_PREFIX + oid);
}

export function subscribeToStyleguideChannel(stid) {
    return subscribeToChannel(STYLEGUIDE_CHANNEL_PREFIX, stid);
}

export function unsubscribeFromStyleguideChannel(stid) {
    pusher.unsubscribe(STYLEGUIDE_CHANNEL_PREFIX + stid);
}

export function subscribeToProjectChannel(pid) {
    return subscribeToChannel(PROJECT_CHANNEL_PREFIX, pid);
}

export function unsubscribeFromProjectChannel(pid) {
    pusher.unsubscribe(PROJECT_CHANNEL_PREFIX + pid);
}

export function subscribeToBarrelChannel(barrelType, bid) {
    if (barrelType === BarrelType.PROJECT) {
        subscribeToProjectChannel(bid);
    } else {
        subscribeToStyleguideChannel(bid);
    }
}

export function unsubscribeFromBarrelChannel(barrelType, bid) {
    if (barrelType === BarrelType.PROJECT) {
        unsubscribeFromProjectChannel(bid);
    } else {
        unsubscribeFromStyleguideChannel(bid);
    }
}
